import { useTranslation } from 'react-i18next';

export function usePageSizePreference(
  transactionKeys: {
    pageSizeTitleKey: string;
    pageCountKey: string;
  },
  pageSizes: number[] = [5, 10, 25, 50],
  namespace: string[] = ['translation']
) {
  const { t } = useTranslation(namespace);

  return {
    title: t(`${transactionKeys.pageSizeTitleKey}`),
    options: pageSizes.map((size) => ({
      value: size,
      label: t(`${transactionKeys.pageCountKey}`, { count: size }),
    })),
  };
}
